var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    fill: "#22ba8e",
    r: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.3748949 36.7876978c-.9812421 0-1.8836696.3854716-2.6120481 1.0276997l-8.7339744-5.0340437c0-.0303255.0039408-.0599772.0039408-.0909766 0-.0330212-.0039408-.0640207-.0039408-.096368l8.4285677-5.1694978c.7993117.8039644 1.835724 1.2932169 2.9719683 1.2932169 2.5233816 0 4.5705916-2.3990891 4.5705916-5.3581903 0-2.9591011-2.0478668-5.359538-4.5712484-5.359538-2.5214113 0-4.5646806 2.3957196-4.5686213 5.3514512l-8.4955601 5.2308229c-.7776377-.7426394-1.7680748-1.1887621-2.8478352-1.1887621-2.4938262 0-4.516735 2.372133-4.516735 5.2968652 0 2.9233843 2.0229088 5.2948434 4.516735 5.2948434 1.0751629 0 2.0616593-.4420793 2.8373266-1.1786535l8.6774905 4.8541119c-.0026271.0774987-.0098518.1536495-.0098518.2331699 0 2.8222992 1.9486917 5.1061511 4.3531946 5.1061511 2.404503 0 4.3545082-2.2845258 4.3545082-5.1061511 0-2.8196036-1.9493485-5.1061511-4.3545082-5.1061511z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareRound);
export default __webpack_public_path__ + "static/media/share-round.e8b8d2ee53e83c358aea195d403412f0.svg";
export { ForwardRef as ReactComponent };